import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { AbsolutePositioned } from '../../../../components/Layout/AbsolutePositioned';
import {
  Screen,
  SplitScreen,
  SplitScreenContentHolder
} from '../../../../components/Layout/Screen';
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import LineLink from '../../../../components/LineLink';
import TextBlock from '../../../../components/TextBlock';
import Title from '../../../../components/Title';
import SocialMedia from '../../../../components/SocialMedia';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import office from '../../../../assets/images/RD_Team_image_2_blue.jpg';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: url(${office});
  background-size: cover;
  background-position: left;

  @media only screen and (max-width: 1000px) {

    background-position-x: -290px;
  }
  }
`;

const Overlay = AbsolutePositioned.extend`
  background: hsla(234, 20%, 30%, 0.6);
  height: 50%;
`;

const LineLinksPosition = AbsolutePositioned.extend`
  width: 100%;
  box-sizing: border-box;

  .featureLineLinks {
    position: relative;
    width: 80%;
    pointer-events: all;
  }
`;

const LineLinksSplitScreenContent = SplitScreenContentHolder.extend`
  padding: 0 0 0 40px;
  @media ${device.laptop} {
    padding: 0 0 0 108px;
  }
`;

const ContentHolder = styled.div`
  position: relative;
  padding: 0;
  height: 100%;
  width: 100%;
`;

const TextBlockContainer = styled.div`
  margin: 122px 0 0 0;
`;

const TitleContainer = styled.div`
  margin: -57px 0 0 0;
  @media ${device.tablet} {
    margin: -89px 0 0 0;
  }
`;

const FooterScreen = () => (
  <StyledScreen className="footer-screen">
    <ContentHolder>
      <ContentContainer>
        <TextBlockContainer>
          <TextBlock color={brandColors.white}>
            <p>
              We&apos;re very passionate about what we do because we believe our work makes a
              difference.
            </p>
          </TextBlock>
        </TextBlockContainer>
      </ContentContainer>
    </ContentHolder>
    <Overlay top="unset" bottom="0" right="0">
      <ContentHolder>
        <ContentContainer>
          <TitleContainer>
            <SocialMedia />
            <Title color={brandColors.white}>Connect with us</Title>
          </TitleContainer>
        </ContentContainer>

        <LineLinksPosition bottom="13%" top="unset">
          <SplitScreen>
            <LineLinksSplitScreenContent direction="right">
              <LineLink
                className="featureLineLinks"
                linkText="how do we do it"
                subtitle="see our services"
                linkColor={brandColors.orange}
                route="/services"
                lineAnimate
                active
              />
            </LineLinksSplitScreenContent>
          </SplitScreen>
          <SplitScreen>
            <LineLinksSplitScreenContent direction="left">
              <LineLink
                className="featureLineLinks"
                linkText="request a quote"
                subtitle="contact us"
                linkColor={brandColors.yellow}
                route="/contact"
                lineAnimate
                active
              />
            </LineLinksSplitScreenContent>
          </SplitScreen>
        </LineLinksPosition>
      </ContentHolder>
    </Overlay>
  </StyledScreen>
);

export default connect()(FooterScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MakingOfAnIndustryLeader/screens/Footer.jsx